// ./src/App.tsx
import React from "react";
import { SdFlcReactRouterPages } from "@sdflc/react-router-pages";
import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";

import {
  AppProvider,
  useApp,
  GoogleMapsProvider,
  FormFieldTypesProvider,
  ThemeProvider,
} from "@/contexts";
import { LoadingOverlay, Favicon } from "@/components/generic";
import ReactGA from "react-ga4";
import { usePageTracking } from "./hooks";

ReactGA.initialize(import.meta.env.VITE_GOOGLE_TAG);

const AppContent: React.FC = () => {
  const { siteMap, userRoles } = useApp();

  return <SdFlcReactRouterPages siteMap={siteMap} roles={userRoles} />;
};

const AuthenticatedApp: React.FC = () => {
  const { isAuthenticated, isInitializing } = useApp();

  usePageTracking();

  // Show loading while initializing
  if (isInitializing) {
    return <LoadingOverlay visible loadingText="Initializing..." />;
  }

  return (
    <FormFieldTypesProvider
      options={{
        pageSize: 100,
        autoLoad: true,
        isAuthenticated,
      }}
    >
      <AppContent />
    </FormFieldTypesProvider>
  );
};

function App() {
  return (
    <ThemeProvider>
      <Favicon />
      <AppProvider>
        <GoogleMapsProvider>
          <AuthenticatedApp />
        </GoogleMapsProvider>
      </AppProvider>
    </ThemeProvider>
  );
}

export default App;
